package com.tfc.care.tfccare.domain.model

import kotlinx.serialization.Serializable
import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*
import kotlinx.serialization.json.*

@Serializable
data class Message(
    val id: String = "",
    val text: String = "",
    val senderId: String = "",
    val senderType: SenderType = SenderType.STAFF,
    val timestamp: String = "",
    val read: Boolean = false,
    val name: String? = "",
    val imageUrl: String? = null,
    val imageLocalPath: String? = null,
    val messageType: MessageType = MessageType.TEXT
)


@Serializable
enum class MessageType {
    TEXT,
    IMAGE
}

@Serializable
enum class SenderType {
    USER,
    STAFF
}

@Serializable
data class ConversationMetadata(
    val unreadCount: Int = 0,
    val lastMessage: String = "",
    val lastMessageTime: String = "",
)

//for staff

@Serializable
data class Conversation(
    val userId: String = "",
    val userName: String = "",
    val companyName: String = "",
    val userEmail: String = "",
    val userNumber: String = "",
    val userImg: String = "",
    val fcmToken: String = "",
    val lastMessage: String = "",
    val lastMessageTime: String = "",
    val unreadCount: Int = 0,
    val lastSeen: String = "",
    val isOnline: Boolean = false,
)


@Serializable
data class StaffChatState(
    val conversations: List<Conversation> = emptyList(),
    val selectedUser: Conversation? = null,
    val messages: List<Message> = emptyList(),
    val isLoading: Boolean = false,
    val isRestoringSession: Boolean = true, // New field to track initial load
    val error: String? = null,
    val isDarkTheme: Boolean = false
)


@Serializable
data class StaffEngagement(
    val dayCount: Int = 0,
    val monthCount: Int = 0,
    val previousMonthCount: Int = 0,
    val lastUpdatedDay: String = "",
    val lastUpdatedMonth: String = ""
)

@Serializable
data class Staff(
    val id: String = "",
    val isValid: Boolean = false,
    val userName: String? = null,
    val online: Boolean = false,
    val emailId: String = "",
    val engagement: StaffEngagement? = null
)

@Serializable
data class FcmV1Request(
    val message: Message
) {
    @Serializable
    data class Message(
        val token: String,
        val notification: Notification? = null,
        val data: Map<String, String>? = null
    )

    @Serializable
    data class Notification(
        val title: String,
        val body: String
    )
}